const equalizersRegistry = new WeakMap();
const rowTopTolerance = 4;

const getCareerWhyItems = (itemsList) => {
	return Array.from(itemsList.querySelectorAll('.career-why-sec__item'));
};

const getCareerWhyItemRows = (itemsList) => {
	const items = getCareerWhyItems(itemsList);
	const rows = [];

	items.forEach((item) => {
		const top = item.getBoundingClientRect().top;
		const existingRow = rows.find((row) => {
			return Math.abs(row.top - top) <= rowTopTolerance;
		});

		if (existingRow) {
			existingRow.items.push(item);
			existingRow.top = Math.min(existingRow.top, top);
			return;
		}

		rows.push({
			top,
			items: [item],
		});
	});

	return rows
		.sort((a, b) => a.top - b.top)
		.map((row) => row.items);
};

const getCareerWhyTitleGroups = (itemsList) => {
	const rows = getCareerWhyItemRows(itemsList);
	const groups = [];

	rows.forEach((row) => {
		const titles = row
			.map((item) => item.querySelector('.career-why-sec__item-title'))
			.filter(Boolean);

		if (titles.length) {
			groups.push(titles);
		}
	});

	return groups;
};

const setupCareerWhyTitleEqualizer = (itemsList) => {
	const equalizer = equalizersRegistry.get(itemsList);

	if (equalizer) {
		equalizer.refresh();
		return;
	}

	if (typeof window.lineTitlesFunc !== 'function') {
		return;
	}

	equalizersRegistry.set(
		itemsList,
		window.lineTitlesFunc([], {
			getGroups: () => getCareerWhyTitleGroups(itemsList),
		})
	);
};

const initCareerWhyItems = (scope = document) => {
	const careerWhySecArr = scope.querySelectorAll('.career-why-sec');

	careerWhySecArr.forEach((careerWhySec) => {
		const itemsList = careerWhySec.querySelector('.career-why-sec__items');

		if (!itemsList || !getCareerWhyItems(itemsList).length) {
			return;
		}

		setupCareerWhyTitleEqualizer(itemsList);
	});
};

initCareerWhyItems();
window.initCareerWhyItems = initCareerWhyItems;
